import React, { useState } from 'react';
import UserService from './service';

interface UserCreateModalProps {
  onClose: () => void;
  onUserCreated: () => void;
}

const UserCreateModal: React.FC<UserCreateModalProps> = ({ onClose, onUserCreated }) => {
  const [user, setUser] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    user_type_id: 1,
    user: Number(localStorage.getItem('user_id')),
    type_invitation: 'email',
    subdomain: 'subdominio1',
  });

  const [inputValue, setInputValue] = useState('');
  const [emailError, setEmailError] = useState(false);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = event.target;
    setUser({ ...user, [name]: value });

    if (name === 'type_invitation') {
      setInputValue('');
      setEmailError(false); // Reset validation if switching type
    }
  };

  const handleDynamicInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setInputValue(value);

    if (user.type_invitation === 'email') {
      setEmailError(!/^\S+@\S+\.\S+$/.test(value)); // Basic email validation
    }
  };

  const handleSubmit = async () => {
    if (user.type_invitation === 'email' && emailError) return;

    try {
      const payload = {
        ...user,
        [user.type_invitation === 'email' ? 'email' : 'phone_number']: inputValue,
      };
      await UserService.createdInvitation(payload);
      onUserCreated();
      onClose();
    } catch (error) {
      console.error('Error creating user:', error);
    }
  };

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-80'>
      <div className='bg-gray-800 rounded-lg p-6 w-96 space-y-4 text-white'>
        <h2 className='text-lg font-semibold'>Create User</h2>
        <div className='flex gap-2'>
          <input
            type='text'
            name='first_name'
            value={user.first_name}
            onChange={handleInputChange}
            placeholder='First Name'
            className='text-white w-1/2 px-3 py-2 bg-gray-700 border border-gray-600 rounded focus:outline-none focus:ring focus:ring-blue-500'
          />
          <input
            type='text'
            name='last_name'
            value={user.last_name}
            onChange={handleInputChange}
            placeholder='Last Name'
            className='text-white w-1/2 px-3 py-2 bg-gray-700 border border-gray-600 rounded focus:outline-none focus:ring focus:ring-blue-500'
          />
        </div>
        <select
          name='user_type_id'
          value={user.user_type_id}
          onChange={handleInputChange}
          className='text-white w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded focus:outline-none focus:ring focus:ring-blue-500'
        >
          <option value='2'>Staff</option>
          <option value='3'>Owner</option>
        </select>

        {/* Section for sending preference */}
        <div>
          <p className='mb-2'>Preferred Invitation Method:</p>
          <div className='flex gap-4 mb-4'>
            <button
              onClick={() =>
                handleInputChange({ target: { name: 'type_invitation', value: 'email' } } as any)
              }
              className={`px-4 py-2 rounded focus:outline-none ${
                user.type_invitation === 'email'
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-700 text-gray-300'
              }`}
            >
              Email
            </button>
            <button
              onClick={() =>
                handleInputChange({ target: { name: 'type_invitation', value: 'phone' } } as any)
              }
              className={`px-4 py-2 rounded focus:outline-none ${
                user.type_invitation === 'phone'
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-700 text-gray-300'
              }`}
            >
              Phone
            </button>
          </div>

          {/* Dynamic input for email or phone */}
          <input
            type={user.type_invitation === 'email' ? 'email' : 'text'}
            name={user.type_invitation}
            value={inputValue}
            onChange={handleDynamicInputChange}
            placeholder={
              user.type_invitation === 'email' ? 'Enter email address' : 'Enter phone number'
            }
            className={`text-white w-full px-3 py-2 bg-gray-700 border ${
              emailError ? 'border-red-500' : 'border-gray-600'
            } rounded focus:outline-none focus:ring focus:ring-blue-500`}
          />
          {emailError && user.type_invitation === 'email' && (
            <p className='text-red-500 text-sm mt-1'>Please enter a valid email address.</p>
          )}
        </div>

        <div className='flex justify-end space-x-2'>
          <button
            onClick={onClose}
            className='px-4 py-2 bg-gray-700 text-gray-300 rounded hover:bg-gray-600'
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className='px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600'
          >
            Create
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserCreateModal;
